import { FC, useRef } from "react";
import { IQrCode } from "../../models";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { getQRCodeUrl } from "../../../../common/components/route/routeHelpers";

export const CodeGenerator = (data: ICodeGenerator) => {
  let navigate = useNavigate();

  const generator = useRef(null);
  const print = useReactToPrint({
    contentRef: generator,
    documentTitle: data.item.description.replace(" ", "-"),
  });

  const gotToQR = (item: IQrCode) => {
    navigate(getQRCodeUrl(item.id));
    data.onClose?.();
  };

  return (
    <div ref={generator} className="bg-white rounded-lg mx-auto px-5 py-8">
      <div className="flex flex-col space-y-5 justify-center items-center text-center">
        <img src="/img/logo_foundat_alt.svg" alt="logo" className="w-1/2" />
        <div className="flex flex-col justify-center items-center">
          <p>
            <strong>Check-in Point</strong>
          </p>
          <p>{data.item.description}</p>
        </div>
        <QRCode
          size={256}
          value={`{https://www.foundat.com/app,"ast":0,"la":${data.item.latitude},"lo":${data.item.longitude},"a":${data.item.altitude},"h":${data.item.heading}}`}
          viewBox={`0 0 256 256`}
          className="w-3/5"
        />
        <small>
          latitude: {data.item.latitude}, longtitude: {data.item.longitude},
          altitude {data.item.altitude}, heading: {data.item.heading}
        </small>
        <div className="flex flex-row space-x-3 justify-center items-center">
          <button
            type="button"
            className="border rounded font-medium px-3 py-2 text-sm text-slate-500 hover:bg-logo hover:text-white print:hidden"
            onClick={() => gotToQR(data.item)}
          >
            View On Map
          </button>
          <button
            type="button"
            className="border rounded font-medium px-3 py-2 text-sm text-slate-500 hover:bg-logo hover:text-white print:hidden"
            onClick={() => print()}
          >
            Print to PDF
          </button>
          <button
            type="button"
            className="border rounded font-medium px-3 py-2 text-sm text-slate-500 hover:bg-logo hover:text-white print:hidden"
            onClick={() => data.edit?.(data.item)}
          >
            Edit Check-In Point
          </button>
        </div>
      </div>
    </div>
  );
};

interface ICodeGenerator {
  item: IQrCode;
  edit?: (item: IQrCode) => void;
  onClose?: () => void;
}
